export enum ActionType {
  Photo = "Pořízení fotografie",
  Medicine = "Podání léků",
}
